import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbMassiveItem} from './nbinput.entity';

@Component({
  selector: 'nbinput-check',
  template: require('./nbinput-check.component.html'),
  styles: [require('./nbinput-check.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputCheckComponent),
      multi: true
    }
  ]
})

export class NbinputCheckComponent implements ControlValueAccessor {
  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};
  registerOnChange(fn: any): void {if (fn) {this.onChangeCallback = fn; }}
  registerOnTouched(fn: any): void {if (fn) {this.onTouchedCallback = fn; }}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled}
  writeValue(obj: any|any[]): void {
    this.data = obj;
  }
  onBlur() { this.onTouchedCallback(); }
  public disabled = false;
  @Input() public readonly = false;

  _items: Array<NbMassiveItem> = [];
  @Input()
  set options(val) {
    if (typeof val === 'object' && val !== null) {
      if (typeof val.length === 'number') {
        this._items = val;
      } else {
        this._items = [val];
      }
    } else {
      this._items = [];
    }
    this._items.forEach(o => o.label = o.text);
    this.resetSelection();
  }
  _selected: any[] = [];
  _data: any[] = [];
  @Input()
  set data(val) {
    if (typeof val === 'object' && val !== null && typeof val.length === 'number') {
      this._data = val;
    } else {
      this._data = [val];
    }
    this.resetSelection();
  }
  get data() {
      return this._selected.map((x, i) => x ? this._items[i].value : null).filter(x => x != null);
  }
  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }
  resetSelection() {
      this._selected = [];
      if (this._data && this._data.length > 0 && this._items && this._items.length > 0) {
          this._items.forEach(o => {
              this._selected.push(this._data.indexOf(o.value) >= 0);
              // o.checked = (this._data.indexOf(o.value)>=0);
          });
      }
  }
  showData() {
    return this._selected.map((x, i) => x ? this._items[i].text : null).filter(x => x != null).join(',');
  }

  @Output() public onChange: EventEmitter<any> = new EventEmitter();
  changed(i) {
    this._data = this.data;
    this.onChange.emit(this.data);
    this.onChangeCallback(this.data);
  }
}
